import {Module} from "../index";
import {
  Competition,
  CompetitionPlayerLog,
  CupCompetition,
  CupWithGroupCompetition,
  Division,
  DivisionPromotion,
  FriendlyCompetition,
  KODivision,
  LeagueCompetition,
  LeagueDivision,
  Matchday,
  Suspension,
  TableStatistics
} from './entity';
import CupCompetitionFactory from "@/modules/competitions/services/factories/CupCompetitionFactory";
import CountryCompetitionFactory from "@/modules/competitions/services/factories/CountryCompetitionFactory";
import KODivisionMatchGenerator from "@/modules/competitions/services/divisions/KODivisionMatchGenerator";
import MatchdayEvaluator from "@/modules/competitions/services/evaluators/MatchdayEvaluator";
import KODivisionPromotionEvaluator from "@/modules/competitions/services/evaluators/KODivisionPromotionEvaluator";
import LeagueCompetitionFactory from "@/modules/competitions/services/factories/LeagueCompetitionFactory";
import LeagueDivisionMatchGenerator from "@/modules/competitions/services/divisions/LeagueDivisionMatchGenerator";
import TableStatisticsGenerator from "@/modules/competitions/services/stats/TableStatisticsGenerator";
import {
  KoDivisionPromotionEventSubscriber
} from "@/modules/competitions/subscribers/KoDivisionPromotionEventSubscriber";
import {TableStatisticsEventSubscriber} from "@/modules/competitions/subscribers/TableStatisticsEventSubscriber";
import messages from "./resources/messages";
import {
  LeagueDivisionPromotionEventSubscriber
} from "@/modules/competitions/subscribers/LeagueDivisionPromotionEventSubscriber";
import DivisionTableStatisticsGenerator
  from "@/modules/competitions/services/divisions/DivisionTableStatisticsGenerator";
import {
  CupCompetitionSchedulingEventSubscriber
} from "@/modules/competitions/subscribers/CupCompetitionSchedulingEventSubscriber";
import CupCompetitionMatchdayGenerator from "@/modules/competitions/services/divisions/CupCompetitionMatchdayGenerator";
import {ActionScreensEventSubscriber} from "@/modules/competitions/subscribers/ActionScreensEventSubscriber";
import {
  CupDivisionPromotionEventSubscriber
} from "@/modules/competitions/subscribers/CupDivisionPromotionEventSubscriber";
import RandomMatchEvaluator from "@/modules/competitions/services/evaluators/RandomMatchEvaluator";
import {StadiumModule} from "@/modules/stadium";
import SpectatorHandler from "@/modules/competitions/services/SpectatorHandler";
import {MatchSpectatorsEventSubscriber} from "@/modules/competitions/subscribers/MatchSpectatorsEventSubscriber";
import {CompetitionLogEventSubscriber} from "@/modules/competitions/subscribers/CompetitionLogEventSubscriber";
import CompetitionPlayerLogger from "@/modules/competitions/services/CompetitionPlayerLogger";
import SuspensionHandler from "@/modules/competitions/services/SuspensionHandler";
import {SuspensionEventSubscriber} from "@/modules/competitions/subscribers/SuspensionEventSubscriber";
import {PlayerSuspendedNotification} from "@/modules/competitions/entity/PlayerSuspendedNotification";
import {routes} from "./resources/routes";
import {
  CompetitionPlayerLogQueryOrder
} from "@/modules/competitions/services/query-paginator/CompetitionPlayerLogQueryOrder";
import {FriendlyEventSubscriber} from "@/modules/competitions/subscribers/FriendlyEventSubscriber";
import SkillBasedMatchEvaluator from "@/modules/competitions/services/evaluators/SkillBasedMatchEvaluator";

export class CompetitionModule extends Module {
  dependsOn = [
    StadiumModule,
  ];

  messages = messages;
  routes = routes;

  eventSubscribers = [
    KoDivisionPromotionEventSubscriber,
    TableStatisticsEventSubscriber,
    LeagueDivisionPromotionEventSubscriber,
    CupCompetitionSchedulingEventSubscriber,
    ActionScreensEventSubscriber,
    CupDivisionPromotionEventSubscriber,
    MatchSpectatorsEventSubscriber,
    CompetitionLogEventSubscriber,
    SuspensionEventSubscriber,
    FriendlyEventSubscriber,
  ];

  public entities = [
    Matchday,
    Competition,
    LeagueCompetition,
    CupCompetition,
    FriendlyCompetition,
    CupWithGroupCompetition,
    Division,
    KODivision,
    LeagueDivision,
    DivisionPromotion,
    TableStatistics,
    CompetitionPlayerLog,
    Suspension,
    PlayerSuspendedNotification,
  ];

  protected register() {
    super.register();

    this.app.bind<CupCompetitionFactory>(CupCompetitionFactory).to(CupCompetitionFactory);
    this.app.bind<CountryCompetitionFactory>(CountryCompetitionFactory).to(CountryCompetitionFactory);
    this.app.bind<KODivisionMatchGenerator>(KODivisionMatchGenerator).to(KODivisionMatchGenerator);
    this.app.bind<CupCompetitionMatchdayGenerator>(CupCompetitionMatchdayGenerator).to(CupCompetitionMatchdayGenerator);

    this.app.bind<RandomMatchEvaluator>(RandomMatchEvaluator).to(RandomMatchEvaluator);
    this.app.bind<SkillBasedMatchEvaluator>(SkillBasedMatchEvaluator).to(SkillBasedMatchEvaluator);

    this.app.bind<MatchdayEvaluator>(MatchdayEvaluator).to(MatchdayEvaluator);
    this.app.bind<KODivisionPromotionEvaluator>(KODivisionPromotionEvaluator).to(KODivisionPromotionEvaluator);
    this.app.bind<TableStatisticsGenerator>(TableStatisticsGenerator).to(TableStatisticsGenerator);
    this.app.bind<DivisionTableStatisticsGenerator>(DivisionTableStatisticsGenerator).to(DivisionTableStatisticsGenerator);

    this.app.bind<LeagueCompetitionFactory>(LeagueCompetitionFactory).to(LeagueCompetitionFactory);
    this.app.bind<LeagueDivisionMatchGenerator>(LeagueDivisionMatchGenerator).to(LeagueDivisionMatchGenerator);

    this.app.bind<SpectatorHandler>(SpectatorHandler).to(SpectatorHandler);
    this.app.bind<CompetitionPlayerLogger>(CompetitionPlayerLogger).to(CompetitionPlayerLogger);
    this.app.bind<SuspensionHandler>(SuspensionHandler).to(SuspensionHandler);

    this.app.bind<CompetitionPlayerLogQueryOrder>(CompetitionPlayerLogQueryOrder).to(CompetitionPlayerLogQueryOrder);
  }

  boot() {
    super.boot();
  }
}
